<template>
  <a href="#" class="link link-rep">
    <span class="rep-circle">+3</span>
    <span class="info">
      <span>Enjoying your conversation?</span><span class="text">Give {{ user.firstname }} +3 Reputation</span>
    </span>
  </a>
</template>

<script>
import { db } from '@/firebase'

export default {
  name: 'GiveReputation',
  props: ['member'],
  firebase () {
    return {
      user: {
        source: db.ref('users/' + this.member),
        asObject: true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// GiveReputation.vue?51196196